export const ASC_PROJECT_BULK_UPLOAD_ONESCHEMA_TEMPLATE_KEY = 'asc-project-upload-v1';
